import React from 'react';

interface MenuScreenProps {
  startGame: () => void;
  openSettings: () => void;
}

const MenuScreen: React.FC<MenuScreenProps> = ({ startGame, openSettings }) => {
  return (
    <div className="menu-screen">
      <div className="menu-content">
        <h1 className="game-title">TETRIS</h1>
        <div className="menu-buttons">
          <button className="menu-button" onClick={startGame}>
            Start Game
          </button>
          <button className="menu-button" onClick={openSettings}>
            Settings
          </button>
        </div>
      </div>
    </div>
  );
};

export default MenuScreen;